import { useEffect } from 'react';

import type { UseFormRegisterReturn } from 'react-hook-form';
import styled from 'styled-components';

import Input from '@polyai/ui/components/atoms/Input';
import InputError from '@polyai/ui/components/atoms/InputError';
import themeSpacing from '@polyai/ui/styles/config/spacing';

type VariableModalContentProps = {
  inputTestId: string;
  register: UseFormRegisterReturn;
  errorMessage?: string;
};

const ErrorArea = styled.div`
  display: flex;
  align-items: flex-start;
  height: ${themeSpacing.sm3};
  padding-top: ${themeSpacing.xxs2};
`;

export const VariableModalContent = ({
  inputTestId,
  register,
  errorMessage,
}: VariableModalContentProps) => {
  const id = 'variable-name-input';

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing deps are intentional
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const input = document.getElementById(id) as HTMLInputElement;
      if (input) {
        input.focus();
      }
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [id]);

  return (
    <div>
      <Input
        aria-autocomplete="none"
        autoComplete="off"
        data-test-id={inputTestId}
        errors={[]}
        id={id}
        label="Variable name"
        fullWidth
        required
        {...register}
      />
      <ErrorArea>
        <InputError errors={errorMessage ? [errorMessage] : []} />
      </ErrorArea>
    </div>
  );
};

export default VariableModalContent;
